<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-3 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Notaría Virtual
                  <span>Su notaría del Siglo XXI</span>
                </h1>
                <p class="lead  text-white">
                  Permita a sus clientes interactuar con la notaría mediante su área privada.
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >INSTALAR en NOTARÍA</span
                    >
                  </a>
                  <a
                    target="_blank"
                    href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_medium=header"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                  >
                    <i style="color: red" class="fa fa-globe"></i>
                    <span class="btn-inner--text"
                      >Probar DEMO online</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  <div class="profile-page">
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      v-lazy="'img/LOGO-NV.png'"
                      class="rounded-circle rounded-notin bg-white"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
              
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
            
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-lg-12 text-center mt-5"><br><br><br>
                    <h3>
                      Notaría Virtual
                    </h3>
                </div>
            </div>
            <div class="mt-2 py-2 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <p>
                    Plataforma digital que revoluciona la gestión notarial al ofrecer un acceso personal web.<br>
                    Permite a los clientes interactuar con su información de forma segura y 
                    desde cualquier dispositivo, garantizando la privacidad de los datos con estrictas medidas de seguridad.

                  </p>
                  <!-- <a href="#">Show more</a> -->
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4 px-5">
                      <h3>Área privada del cliente</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4 px-5">
                      <ul class="list-unstyled mt-2">
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-home"
                              ></badge>
                              <h6 class="mb-0">Portal de Inicio</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-purple text-white"
                              icon="fa fa-plus-circle"
                              ></badge>
                              <h6 class="mb-0">Solicitudes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                                type="success"
                                circle
                                class="mr-3 bg-green text-white"
                                icon="fa fa-book"
                              ></badge>
                              <h6 class="mb-0">Operaciones</h6>
                          </div>
                          </li>
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-grey text-white"
                              icon="fa fa-file-word-o"
                              ></badge>
                              <h6 class="mb-0">Documentos Online</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-file-archive-o"
                              ></badge>
                              <h6 class="mb-0">Archivos Digitales</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-red text-white"
                              icon="fa fa-folder-open"
                              ></badge>
                              <h6 class="mb-0">Copias y Facturas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-pink text-white"
                              icon="fa fa-pencil"
                              ></badge>
                              <h6 class="mb-0">Datos Personales, LOPD, etc.</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-plus "
                              ></badge>
                              <h6 class="mb-0">Y mucho más... </h6>
                          </div>
                          </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <a target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_source=notin-web&utm_medium=header">
                        <img class="w100 pt-2 pl-2 pr-2" v-lazy="'img/mockup-nmp.jpg'"/>
                        
                      </a>
                    </div>
                    <!-- <a href="#">Show more</a> -->
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
    <section class="section section-lg pt-lg-0 ">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
              <h2 class="display-3 text-center">Productividad para sus clientes y notaría</h2>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-badge"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Datos Personales</h6>
                  <p class="description mt-3">
                    Reduzca el número de errores mediante la comprobación de los datos personales por parte del cliente.
                  </p>
                  <div>
                    <badge type="primary" rounded>Alta de clientes</badge>
                    <badge type="primary" rounded>datos personales</badge>
                    <badge type="primary" rounded>Documentos Identificación</badge>
                    <badge type="primary" rounded>LOPD</badge>
                  </div>
                  <base-button tag="a" target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?urm_source=notin&utm_source=notin-web&utm_medium=documentos-personales" type="primary" class="mt-4">
                    Probar Notaría Virtual
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-single-copy-04"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Documentos</h6>
                  <p class="description mt-3">
                    Permita que su cliente interactúe con el documento desde su inicio hasta la firma.
                  </p>
                  <div>
                    <badge type="success" rounded>Notas en documento</badge>
                    <badge type="success" rounded>Comentarios señalizados</badge>
                    <badge type="success" rounded>Lectura del borrador</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="success" class="mt-4">
                    Instalar en mi NOTARÍA
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-send" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Solicitudes</h6>
                  <p class="description mt-3">
                    Facilite la recopilación de información a su oficial para los nuevos asuntos.
                  </p>
                  <div>
                    <badge type="warning" rounded>Recopilación de datos</badge>
                    <badge type="warning" rounded>Tipo de documento</badge>
                    <badge type="warning" rounded>Pago de provisión</badge>
                  </div>
                  <base-button tag="a" target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_source=notin-web&utm_medium=solicitudes" type="warning" class="mt-4">
                    Probar Notaría Virtual
                  </base-button>
                </card>
              </div>
            </div>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-cloud-upload-96"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Archivos Digitales</h6>
                  <p class="description mt-3">
                    Se acabaron los correos con PDFs e imágenes. Solicite documentos que irán directamente al asunto.
                  </p>
                  <div>
                    <badge type="primary" rounded>Petición de documentos</badge>
                    <badge type="primary" rounded>Incorporación en Kubo</badge>
                    <badge type="primary" rounded>Privacidad entre clientes</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="primary" class="mt-4">
                    Instalar en mi NOTARÍA
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-paper-diploma"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Copias</h6>
                  <p class="description mt-3">
                    Evite esperas a sus clientes con el permiso de visualizar la copia en su área privada.
                  </p>
                  <div>
                    <badge type="success" rounded>Visualización de copias</badge>
                    <badge type="success" rounded>Control del tiempo disponible</badge>
                    <badge type="success" rounded>Copia tras cobro de factura</badge>
                  </div>
                  <base-button tag="a" target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_source=notin-web&utm_medium=copias" type="success" class="mt-4">
                    Probar Notaría Virtual
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-credit-card" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Facturas</h6>
                  <p class="description mt-3">
                    Reduzca sus facturas adeudadas incorporando la factura y pago online en el área del cliente.
                  </p>
                  <div>
                    <badge type="warning" rounded>Visualización Facturas</badge>
                    <badge type="warning" rounded>Facturas de Trámite</badge>
                    <badge type="warning" rounded>Pago de forma Online</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="warning" class="mt-4">
                    Instalar en mi NOTARÍA
                  </base-button>
                </card>
              </div>
            </div>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-calendar-grid-58"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Agenda</h6>
                  <p class="description mt-3">
                    Mantenga a su cliente informado sobre todos los detalles necesarios, incluyendo la fecha y hora de la firma-
                  </p>
                  <div>
                    <badge type="primary" rounded>Notificación vía SMS y EMAIL</badge>
                    <badge type="primary" rounded>Información completa de la firma</badge>
                    <badge type="primary" rounded>Documentos necesarios</badge>
                  </div>
                  <base-button tag="a" target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_source=notin-web&utm_medium=agenda" type="primary" class="mt-4">
                    Probar Notaría Virtual
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-chat-round"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Chat</h6>
                  <p class="description mt-3">
                    Reduzca los WhatsApp, llamadas y correos de sus oficiales mediante mensajes directos con clientes.
                  </p>
                  <div>
                    <badge type="success" rounded>Chat por operación</badge>
                    <badge type="success" rounded>Chat por clientes</badge>
                    <badge type="success" rounded>Permisos de escritura</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="success" class="mt-4">
                    Instalar en mi NOTARÍA
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-app" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Versatilidad</h6>
                  <p class="description mt-3">
                    Adapte cada área privada a cada uno de sus clientes.
                  </p>
                  <div>
                    <badge type="warning" rounded>Clientes Fijos</badge>
                    <badge type="warning" rounded>Permisos por operación</badge>
                    <badge type="warning" rounded>Permisos por cliente</badge>
                    <badge type="warning" rounded>Revocación de acceso</badge>
                  </div>
                  <base-button tag="a" target="_blank" href="https://aula.notin.es/proyectos-en-curso/notaria-virtual-la-salida-de-nuestra-notaria-a-la-red/nv-probar-la-notaria-virtual?utm_source=notin-web&utm_medium=versatilidad" type="warning" class="mt-4">
                    Probar Notaría Virtual
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-12 mt-5">
              <card class=" bg-gradient-success border-0" shadow body-classes="py-5">
                <h4 class="text-center"><b>Valores de adaptación</b></h4>
              <h5 class=" text-center">
                 Detrás de la notaría virtual hay un equipo que valora las peticiones de los usuarios y trata constantemente de adaptar el producto a las peculiaridades del entorno y a la mejora continua de los procesos para avanzar en eficacia y productividad. Una petición de cambio no es un problema sino una puesta en valor del uso razonado de nuestra herramienta.
              </h5>
              </card>
          </div>
        </div>
      </div>
    </section>
    
    

   
  </div>
</template>

<script>

export default {
  name: "notaria-virtual",
};
</script>
<style scoped>

</style>